<template lang="pug">
.calendar_row(@click='toggle')
  CalendarCell(
    v-for='(day, index) in days',
    :day='day',
    :key='index',
    :data='data',
    :row-count='rowCount',
    :open='open',
  )
</template>

<script>
import CalendarCell from './CalendarCell';
export default {
  name: 'CalendarRow',
  components: { CalendarCell },
  props: {
    data: {},
    rowCount: Number,
    days: {},
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style scoped lang="stylus">
.calendar_row
  cursor pointer
  border-bottom 1px solid #aaaaaa
  min-height: 70px;
  display flex
  flex-direction row
  &:hover
    background-color: aliceblue;
</style>



// WEBPACK FOOTER //
// CalendarRow.vue?014b31d0